<app-header [redirectUrl]="redirectUrl"></app-header>
<div class="wrapper">
  <div [ngClass]="{ 'padding-remove': !videoDetail }">
    <div class="mortab_error" *ngIf="moreBrowserStatus">
      <div class="text-center error-msg-box">
        <h2 class="text-secondary">
          {{ "VIDEO_DETAIL.MORE_REQUEST" | translate }}
        </h2>
        <p class="font-18">
          {{ "VIDEO_DETAIL.CLOSE_TAB" | translate }}
        </p>
      </div>
    </div>
    <div
      class="detail-page"
      [ngClass]="{
        'cus-playing': isPlaying,
        'audio-poster': videoDetail?.extension === 'audio'
      }"
    >
      <app-poster-simmer *ngIf="shimmerStatus.poster"></app-poster-simmer>
      <section
        class="video-detail"
        *ngIf="!shimmerStatus.poster && !moreBrowserStatus"
      >
        <div class="player" *ngIf="!videoDetail.bannerStatus">
          <app-vjs-player
            *ngIf="
              (videoDetail.type == 'video' || videoDetail.type == 'live') &&
              loading_player &&
              videoDetail.videoStatus
            "
            [scrollStatus]="scrollPosition"
            (playerStatus)="videoStatus($event)"
            [options]="{
              autoplay: autoplay,
              aspectRatio: '16:9',
              controls: true,
              loop: false,
              poster: thumbnails,
              sources: [
                {
                  src: output_url,
                  type: type
                }
              ],
              action: action,
              videoDetail: videoDetail,
              redirectUrl: redirectUrl,
              controlBar: {
                pictureInPictureToggle: true
              }
            }"
          >
          </app-vjs-player>

          <div *ngIf="request_error" class="video-not-support">
            <img [src]="appConstant.BrowserNotSupported" />
            <h4>{{ "VIDEO_DETAIL.MESSAGE3" | translate }}</h4>
          </div>
          <div
            *ngIf="!loading_player && videoDetail && !access && !messageShow"
            class="video-not-support"
          >
            <img [src]="appConstant.BrowserNotSupported" />
            <h4 *ngIf="!errorMessage">
              {{ "VIDEO_DETAIL.MESSAGE" | translate }}
            </h4>
            <h4 *ngIf="errorMessage">{{ errorMessage | translate }}</h4>
          </div>

          <div
            *ngIf="!loading_player && videoDetail && access && !messageShow"
            class="video-not-support"
          >
            <img [src]="appConstant.BrowserNotSupported" />
            <h4>{{ "VIDEO_DETAIL.MESSAGE1" | translate }}</h4>
          </div>
          <div *ngIf="!loading_player && messageShow" class="video-not-support">
            <img [src]="appConstant.BrowserNotSupported" />
            <h4>{{ "VIDEO_DETAIL.MESSAGE2" | translate }}</h4>
          </div>
        </div>
        <div class="video" *ngIf="loading_player && videoDetail.bannerStatus">
          <app-content-subscription
            [videoDetail]="videoDetail"
          ></app-content-subscription>
        </div>
        <div class="video-content" *ngIf="videoDetail">
          <div class="container">
            <div class="banner-content-box">
              <app-video-info
                [videoDetail]="videoDetail"
                [url]="encodeUrl"
                [public_id]="public_id"
                [event]="event"
              >
              </app-video-info>
            </div>
          </div>
        </div>
      </section>
      <app-rectangle-simmer
        class="search-page"
        *ngIf="shimmerStatus.relatedvideo"
      ></app-rectangle-simmer>
      <section
        #vcontent
        [hidden]="shimmerStatus.relatedvideo"
        *ngIf="reletedShows.length > 0"
      >
        <div
          class="multi-slider mt-3 detail-slider"
          *ngIf="!shimmerStatus.relatedvideo"
        >
          <div class="container">
            <div class="section-head">
              <h2>{{ "VIDEO_DETAIL.RELATED_VIDEOS" | translate }}</h2>
            </div>
            <div class="populer-slider" id="slider-top">
              <owl-carousel-o [options]="tradinglearn">
                <ng-container>
                  <ng-template carouselSlide *ngFor="let show of reletedShows">
                    <div class="series-box">
                      <app-grid
                        [data]="show"
                        [gridType]="'portrait'"
                      ></app-grid>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
<app-footer></app-footer>
